























import { defineComponent, ref, computed, useFetch } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';
import { ECSchema } from '~/types/api';

export default defineComponent({
  components: {
    AppImage,
    AppRectButton,
  },
  props: {
    shopId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const shop = ref<ECSchema<'saleslocation.ShowResponse'>>();

    useFetch(async () => {
      shop.value = await store.dispatch('modules/content/fetchShopDetail', {
        path: { id: props.shopId },
        query: { is_permalink: false, target_permalink: '' },
      });
    });

    // 住所
    const address = computed(() => {
      if (!shop.value) {
        return '';
      }
      const { post_no, state_name, city_name, address_name1, address_name2 } = shop.value;

      return `${post_no} ${state_name}${city_name}${address_name1}${address_name2}`;
    });

    // 電話番号・FAX
    const tel = computed(() => {
      if (!shop.value) {
        return '';
      }
      const { tel_no, fax_no } = shop.value;

      return `TEL：${tel_no} ／ FAX：${fax_no}`;
    });

    const detailLink = computed(() => url('SHOP_DETAIL', { permalink: shop.value?.permalink }));

    return { shop, address, tel, detailLink };
  },
});
